var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"100%"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imageUrl},on:{"click":_vm.goPages}})])}
var staticRenderFns = []

export { render, staticRenderFns }